export default class DiscountApi {
    static findDiscountByDiscountCode(discountFetch){
        return fetch(`/api/discount`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify(discountFetch)
        })
        .then(res => res.json())
        .then(
        (result) => {
            return result
        },
        (error) => {
            return error
        }
        )
    }

    static findDiscountByOrderId(orderId){
        return fetch(`/api/discountByOrderId/${orderId}`,{
            method: 'GET',
            headers:new Headers( {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            })
        })
        .then(res => res.json())
        .then(
        (result) => {
            return result
        },
        (error) => {
            return error
        }
        )
    }
}